import { combineReducers } from 'redux';
import menu from './menu/menuSlice';
import opcoesExtrato from './opcoesExtrato/opcoesExtratoSlice';
import profile from './profile/profileSlice';
import authUser from './auth/authSlice';

const reducers = combineReducers({
    authUser,
    menu,
    opcoesExtrato,
    profile
});

export default reducers;